import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  apply(): void {
    const hex = environment.primaryColor;
    const rgb = this.hexToRgb(hex);
    if (!rgb) { return; }

    const shade = this.adjustLightness(rgb, -0.12);
    const tint  = this.adjustLightness(rgb, 0.10);
    const contrast = this.contrastColor(rgb);
    const contrastRgb = this.hexToRgb(contrast);

    const root = document.documentElement;
    root.style.setProperty('--ion-color-primary',              hex);
    root.style.setProperty('--ion-color-primary-rgb',          `${rgb.r},${rgb.g},${rgb.b}`);
    root.style.setProperty('--ion-color-primary-contrast',     contrast);
    root.style.setProperty('--ion-color-primary-contrast-rgb', `${contrastRgb.r},${contrastRgb.g},${contrastRgb.b}`);
    root.style.setProperty('--ion-color-primary-shade',        this.rgbToHex(shade));
    root.style.setProperty('--ion-color-primary-tint',         this.rgbToHex(tint));

    // Update the PWA theme-color meta tag
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) { meta.setAttribute('content', hex); }
  }

  private hexToRgb(hex: string): {r: number; g: number; b: number} | null {
    const clean = hex.replace('#', '');
    const full = clean.length === 3
      ? clean.split('').map(c => c + c).join('')
      : clean;
    const n = parseInt(full, 16);
    if (isNaN(n)) { return null; }
    return {r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255};
  }

  private rgbToHex({r, g, b}: {r: number; g: number; b: number}): string {
    return '#' + [r, g, b].map(v => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0')).join('');
  }

  private adjustLightness({r, g, b}: {r: number; g: number; b: number}, amount: number): {r: number; g: number; b: number} {
    return {
      r: r + (amount < 0 ? r * amount : (255 - r) * amount),
      g: g + (amount < 0 ? g * amount : (255 - g) * amount),
      b: b + (amount < 0 ? b * amount : (255 - b) * amount),
    };
  }

  // Returns #ffffff or #000000 depending on which has better contrast
  private contrastColor({r, g, b}: {r: number; g: number; b: number}): string {
    // Perceived luminance (WCAG formula)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#ffffff';
  }
}
